import { ObservableFromFetch } from "../ObservableFromFetch"
import { format } from "date-fns"

export default function GovPoolCheckTestsExistObservable(poolID: number, date: Date) {
  const params: string = JSON.stringify({
    poolId: poolID.toString(),
    date: format(date, "MM/dd/yyyy")
  })

  return ObservableFromFetch<boolean>("GovPool/CheckTestsExist", params)
}
